import { useThrowableSWR } from 'utils/fetcher';

import {
  PlsAccessorial,
  PlsOperationalFieldDefinition,
  PlsReferenceFieldPage,
} from '../types';

export function usePlsAccessorials(tmsID: number | undefined) {
  const key = tmsID ? `load/options/pls/accessorials?tmsID=${tmsID}` : null;
  const { data, error, isLoading } = useThrowableSWR<PlsAccessorial[]>(
    key,
    false
  );

  return {
    accessorials: Array.isArray(data) ? data : [],
    isLoading: Boolean(key) && isLoading,
    error,
  };
}

export function usePlsOperationalFields(
  tmsID: number | undefined,
  billToExternalTmsId: string | undefined
) {
  const billToId = (billToExternalTmsId ?? '').trim();
  const key =
    tmsID && billToId
      ? `load/options/pls/operational-fields?tmsID=${tmsID}&customerBillToAddressId=${encodeURIComponent(billToId)}`
      : null;
  const { data, error, isLoading } = useThrowableSWR<
    PlsOperationalFieldDefinition[]
  >(key, false);

  return {
    fieldDefinitions: Array.isArray(data) ? data : [],
    isLoading: Boolean(key) && isLoading,
    error,
  };
}

export function usePlsReferenceCatalogs(tmsID: number | undefined) {
  const loadReferencesKey = tmsID
    ? `load/options/pls/load-reference-fields?tmsID=${tmsID}`
    : null;
  const stopReferencesKey = tmsID
    ? `load/options/pls/stop-reference-fields?tmsID=${tmsID}`
    : null;

  const loadReferences = useThrowableSWR<PlsReferenceFieldPage>(
    loadReferencesKey,
    false
  );
  const stopReferences = useThrowableSWR<PlsReferenceFieldPage>(
    stopReferencesKey,
    false
  );

  return {
    loadReferenceFields: loadReferences.data?.items ?? [],
    stopReferenceFields: stopReferences.data?.items ?? [],
    isLoading: {
      loadReferenceFields:
        Boolean(loadReferencesKey) && loadReferences.isLoading,
      stopReferenceFields:
        Boolean(stopReferencesKey) && stopReferences.isLoading,
    },
    errors: {
      loadReferenceFields: loadReferences.error,
      stopReferenceFields: stopReferences.error,
    },
  };
}
